import {
  GET_USER_POINT,
  GET_POINT_TIER,
  GET_POINT_HISTORY,
  GET_USER_VOUCHER,
  GET_USER_RAFFLE,
  GET_VOUCHER_HISTORY,
  GET_RAFFLE_HISTORY,
  PROMISE_FULFILLED,
  PROMISE_REJECTED,
  PROMISE_PENDING
} from '../constants';
import error from '../utils/error';

const initialState = {
  userPoint: {
    data: null,
    isFetching: false,
    error: null,
    status_code: null
  },
  pointTier: {
    data: [],
    isFetching: false,
    error: null,
    status_code: null
  },
  pointHistory: {
    data: [],
    isFetching: false,
    error: null,
    status_code: null,
    last_page: null,
    current_page: null,
    per_page: null,
    total: null
  },
  userVoucher: {
    data: [],
    isFetching: false,
    error: null,
    status_code: null,
    last_page: null,
    current_page: null,
    per_page: null,
    total: null
  },
  userRaffle: {
    data: [],
    isFetching: false,
    error: null,
    status_code: null,
    last_page: null,
    current_page: null,
    per_page: null,
    total: null
  },
  voucherHistory: {
    data: [],
    isFetching: false,
    error: null,
    status_code: null,
    last_page: null,
    current_page: null,
    per_page: null,
    total: null
  },
  raffleHistory: {
    data: [],
    isFetching: false,
    error: null,
    status_code: null,
    last_page: null,
    current_page: null,
    per_page: null,
    total: null
  }
}

const pointHistoryData = (state, { data: { data, last_page, current_page, per_page, total }, status_code }) => {
  let newState = {
    ...state,
    pointHistory: {
      ...state.pointHistory,
      isFetching: false,
      data: [...data],
      status_code,
      last_page,
      current_page,
      per_page,
      total
    }
  }

  return newState
}

const userVoucherData = (state, { data: { data, last_page, current_page, per_page, total }, status_code }) => {
  let newState = {
    ...state,
    userVoucher: {
      ...state.userVoucher,
      isFetching: false,
      data: [...data],
      status_code,
      last_page,
      current_page,
      per_page,
      total
    }
  }

  return newState
}

const userRaffleData = (state, { data: { data, last_page, current_page, per_page, total }, status_code }) => {
  let newState = {
    ...state,
    userRaffle: {
      ...state.userRaffle,
      isFetching: false,
      data: [...data],
      status_code,
      last_page,
      current_page,
      per_page,
      total
    }
  }

  return newState
}

const voucherHistoryData = (state, { data: { data, last_page, current_page, per_page, total }, status_code }) => {
  let newState = {
    ...state,
    voucherHistory: {
      ...state.voucherHistory,
      isFetching: false,
      data: [...data],
      status_code,
      last_page,
      current_page,
      per_page,
      total
    }
  }

  return newState
}

const raffleHistoryData = (state, { data: { data, last_page, current_page, per_page, total }, status_code }) => {
  let newState = {
    ...state,
    raffleHistory: {
      ...state.raffleHistory,
      isFetching: false,
      data: [...data],
      status_code,
      last_page,
      current_page,
      per_page,
      total
    }
  }

  return newState
}

const kickPointReducer = (state = initialState, action) => {
  switch (action.type) {
    case `${GET_USER_POINT}${PROMISE_PENDING}`:
      return { ...state, userPoint: { ...state.userPoint, isFetching: true } }
    case `${GET_USER_POINT}${PROMISE_FULFILLED}`:
      return { ...state, userPoint: { ...state.userPoint, data: action.payload.data.buyer_points_status, isFetching: false, status_code: 200, error: null } }
    case `${GET_USER_POINT}${PROMISE_REJECTED}`:
      return { ...state, userPoint: { ...state.userPoint, isFetching: false, error: error(action.payload) } }

    case `${GET_POINT_TIER}${PROMISE_PENDING}`:
      return { ...state, pointTier: { ...state.pointTier, isFetching: true } }
    case `${GET_POINT_TIER}${PROMISE_FULFILLED}`:
      return { ...state, pointTier: { ...state.pointTier, data: action.payload.data.data, isFetching: false, status_code: 200, error: null } }
    case `${GET_POINT_TIER}${PROMISE_REJECTED}`:
      return { ...state, pointTier: { ...state.pointTier, isFetching: false, error: error(action.payload) } }

    case `${GET_POINT_HISTORY}${PROMISE_PENDING}`:
      return { ...state, pointHistory: { ...state.pointHistory, isFetching: true } }
    case `${GET_POINT_HISTORY}${PROMISE_FULFILLED}`:
      return (pointHistoryData(state, action.payload))
    case `${GET_POINT_HISTORY}${PROMISE_REJECTED}`:
      return { ...state, pointHistory: { ...state.pointHistory, isFetching: false, error: error(action.payload) } }

    case `${GET_USER_VOUCHER}${PROMISE_PENDING}`:
      return { ...state, userVoucher: { ...state.userVoucher, isFetching: true } }
    case `${GET_USER_VOUCHER}${PROMISE_FULFILLED}`:
      return (userVoucherData(state, action.payload))
    case `${GET_USER_VOUCHER}${PROMISE_REJECTED}`:
      return { ...state, userVoucher: { ...state.userVoucher, isFetching: false, error: error(action.payload) } }

    case `${GET_USER_RAFFLE}${PROMISE_PENDING}`:
      return { ...state, userRaffle: { ...state.userRaffle, isFetching: true } }
    case `${GET_USER_RAFFLE}${PROMISE_FULFILLED}`:
      return (userRaffleData(state, action.payload))
    case `${GET_USER_RAFFLE}${PROMISE_REJECTED}`:
      return { ...state, userRaffle: { ...state.userRaffle, isFetching: false, error: error(action.payload) } }

    case `${GET_VOUCHER_HISTORY}${PROMISE_PENDING}`:
      return { ...state, voucherHistory: { ...state.voucherHistory, isFetching: true } }
    case `${GET_VOUCHER_HISTORY}${PROMISE_FULFILLED}`:
      return (voucherHistoryData(state, action.payload))
    case `${GET_VOUCHER_HISTORY}${PROMISE_REJECTED}`:
      return { ...state, voucherHistory: { ...state.voucherHistory, isFetching: false, error: error(action.payload) } }

    case `${GET_RAFFLE_HISTORY}${PROMISE_PENDING}`:
      return { ...state, raffleHistory: { ...state.raffleHistory, isFetching: true } }
    case `${GET_RAFFLE_HISTORY}${PROMISE_FULFILLED}`:
      return (raffleHistoryData(state, action.payload))
    case `${GET_RAFFLE_HISTORY}${PROMISE_REJECTED}`:
      return { ...state, raffleHistory: { ...state.raffleHistory, isFetching: false, error: error(action.payload) } }

    default: return state;
  }
}

export default kickPointReducer;